import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appObserver]',
  standalone: true
})
export class ObserverDirective implements OnInit {
  @Output() leaveEnd: EventEmitter<any> = new EventEmitter<any>();
  @Input() intersectionOptions: {
    root?: HTMLElement;
    rootMargin?: string;
    threshold?: number | number[]
  } = {};

  constructor(
    private element: ElementRef
  ) { }

  ngOnInit(): void {
    if (!window.IntersectionObserver) { return }

    this.intersectionOptions = {
      rootMargin: '0% 0% 0% 0%',
      threshold: [.1],
      ...this.intersectionOptions
    };

    const observer = new window.IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) { return; }
      this.leaveEnd.emit();
    },
      this.intersectionOptions);
    observer.observe(this.element.nativeElement)
  }
}
